import React from 'react'
import GridContainer from '../components/grid-container'
import SectionContainer from '../components/section-container'
import SectionTitle from '../components/section-title'
import SkillCard from '../components/Skills/skill-card'

const skills = [
  {
    title: 'React.js SPA',
    years: 5,
    experience: [
      'React Redux, React Hook',
      'Redux Saga, Redux Thunk',
      'JSX and TSX',
      'MUI, Ant Design, Semantic UI, Recharts',
      'React Native mobile app development',
      'Styled Components',
      'TailwindCSS and WindiCSS, Bootstrap5',
      'Unit testing with Jest/Enzymes',
    ],
    tools: {
      React: 'bg-[url(../public/assets/images/logos/react.svg)]',
      'Next.js': 'bg-[url(../public/assets/images/logos/next.svg)]',
      'Redux-Toolkit': 'bg-[url(../public/assets/images/logos/redux.svg)]',
      'Redux Saga': 'bg-[url(../public/assets/images/logos/redux-saga.svg)]',
      TailwindCSS: 'bg-[url(../public/assets/images/logos/tailwindcss.svg)]',
      'Jest Framework': 'bg-[url(../public/assets/images/logos/jest.svg)]',
    },
  },
  {
    title: 'Vue.js SPA',
    years: 4,
    experience: [
      'Vue.js v2, v3, Vue Composition API',
      'State management with VueX, Nuxt and Vue Composition API',
      'Vue CLI(webpack), Vite, Quasar CLI and Parcel',
      'VitePress, VuePress and Vue Storefront',
      'Mobile app development with Ionic/Vue and Quasar',
      'SSR and SSG with Nuxt.js, Vite-SSG and SEO optimization',
      'TailwindCSS and WindiCSS',
      'Unit testing with Jest/Enzymes',
    ],
    tools: {
      Vue: 'bg-[url(../public/assets/images/logos/vue.svg)]',
      Vuetify: 'bg-[url(../public/assets/images/logos/vuetify.svg)]',
      'Nuxt.js': 'bg-[url(../public/assets/images/logos/nuxt.svg)]',
      'Quasar Framework': 'bg-[url(../public/assets/images/logos/quasar.svg)]',
      TailwindCSS: 'bg-[url(../public/assets/images/logos/tailwindcss.svg)]',
      'Laravel Blade': 'bg-[url(../public/assets/images/logos/laravel-blade.svg)]',
    },
  },
  {
    title: 'Node.js back-end',
    years: 4,
    experience: [
      'Mode.js, Express.js, Koa.js',
      'WebSocket/Socket.io',
      'Pug.js, Jade.js',
      'Passport.js, Moment.js',
      'MongoDB, MySQL, PostgreSQL, GraphSL',
      'Mocha/Chai, Karma',
    ],
    tools: {
      'Node.js': 'bg-[url(../public/assets/images/logos/node.svg)]',
      Websocket: 'bg-[url(../public/assets/images/logos/websocket.svg)]',
      MySQL: 'bg-[url(../public/assets/images/logos/mysql.svg)]',
      MongoDB: 'bg-[url(../public/assets/images/logos/mongodb.svg)]',
      PostgreSQL: 'bg-[url(../public/assets/images/logos/postgresql.svg)]',
    },
  },
  {
    title: 'JavaScript techniques',
    years: 6,
    experience: [
      'JavaScript, ES6+, TypeScript',
      'NPM, Yarn, Webpack, Babel, Grunt, Gulp',
      'jQuery, Ajax, Axios',
      'D3.js, Fabric.js, Pixi.js, Phaser.js, Three.js',
      'Chart libraries',
      'JavaScript Animation',
    ],
    tools: {
      JavaScript: 'bg-[url(../public/assets/images/logos/javascript.svg)]',
      TypeScript: 'bg-[url(../public/assets/images/logos/typescript.svg)]',
      WebPack: 'bg-[url(../public/assets/images/logos/webpack.svg)]',
      Grunt: 'bg-[url(../public/assets/images/logos/grunt.svg)]',
      'D3.js': 'bg-[url(../public/assets/images/logos/d3.svg)]',
    },
  },
  {
    title: 'Team collaboration and CI/CD',
    years: 6,
    experience: [
      'CI/CD with Docker, Jenkins',
      'Asana, Trello and Jira',
      'Agile/Scrum methodologies',
      'Slack, Skype, Telegram, Discord',
      'Good communication',
    ],
    tools: {
      Docker: 'bg-[url(../public/assets/images/logos/docker.svg)]',
      Jira: 'bg-[url(../public/assets/images/logos/jira.svg)]',
      Trello: 'bg-[url(../public/assets/images/logos/trello.svg)]',
      Slack: 'bg-[url(../public/assets/images/logos/slack.svg)]',
      Discord: 'bg-[url(../public/assets/images/logos/discord.png)]',
      Skype: 'bg-[url(../public/assets/images/logos/skype.svg)]',
    },
  },
  {
    title: 'Git and SVN',
    years: 6,
    experience: [
      'GitHub, GitLab and BitBucket',
      'Git Bash, Git GUI',
      'Source Tree, GitKraken',
      'Tortoise SVN',
    ],
    tools: {
      GitHub: 'bg-[url(../public/assets/images/logos/github.svg)]',
      GitLab: 'bg-[url(../public/assets/images/logos/gitlab.svg)]',
      BitBucket: 'bg-[url(../public/assets/images/logos/bitbucket.svg)]',
      'Source Tree': 'bg-[url(../public/assets/images/logos/sourcetree.svg)]',
      GitKraken: 'bg-[url(../public/assets/images/logos/gitkraken.svg)]',
    },
  },
]

const SkillsSection = () => {
  return (
    <SectionContainer
      addClass="bg-[linear-gradient(#000,rgba(0,0,0,0.93),rgba(0,0,0,0.66))]"
      id="skills"
    >
      <SectionTitle>Skills</SectionTitle>
      <GridContainer>
        {skills.map((skill, i) => (
          <SkillCard key={`skill-card-${i}`} {...skill} />
        ))}
      </GridContainer>
    </SectionContainer>
  )
}

export default SkillsSection
